export const calcGeometryDistance = (e1, n1, e2, n2) => {
	const R = 6371

	const { sin, cos, asin, PI, hypot } = Math

	/** 根据经纬度获取点的坐标 */

	let getPoint = (e, n) => {
		e *= PI / 180

		n *= PI / 180

		//这里 R* 被去掉, 相当于先求单位圆上两点的距, 最后会再将这个距离放大 R 倍

		return { x: cos(n) * cos(e), y: cos(n) * sin(e), z: sin(n) }
	}

	let a = getPoint(e1, n1)

	let b = getPoint(e2, n2)

	let c = hypot(a.x - b.x, a.y - b.y, a.z - b.z)

	let r = asin(c / 2) * 2 * R

	return r.toFixed(1)
}

export const getLatestAddress = (address, longitude, latitude) => {
	return address
		.map(item => {
			const [x, y] = item.location.split(',')
			item.distance = calcGeometryDistance(longitude, latitude, x, y)
			return item
		})
		.sort((a, b) => {
			return a.distance - b.distance
		})[0]
}

export const toMoneyFormat = (num, decimalNum) => {
	if (!num) {
		return 0
	}

	let totalString =
		decimalNum && decimalNum > 0 ? num.toFixed(decimalNum).toString() : num.toString()
	let splits = totalString.split('.')
	let intPart = splits[0]
	let decimalPart
	if (splits.length > 1) {
		decimalPart = splits[1]
	}
	let intResult = ''
	while (intPart.length > 3) {
		intResult = ',' + intPart.slice(-3) + intResult
		intPart = intPart.slice(0, intPart.length - 3)
	}
	intResult = intPart + intResult
	return decimalPart ? intResult + '.' + decimalPart : intResult
}
